import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from "@apollo/client";

import { Link, useNavigate } from "react-router-dom";

import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from '../../../../../context/UserContext';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from "primereact/inputtext";
import { InputNumber } from 'primereact/inputnumber';
import { Fieldset } from 'primereact/fieldset';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
//import HtlPeriods from "./HtlPeriods";

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';




const GET_POST = gql`
query MyQuery(
    $seaId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
    ) {
    tbl_htl_season(where: {id_seq: {_eq: $seaId}
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
    }) {
    id_seq
    firm_main_code
    firm_sub_code
    start_date
    end_date
    desc
    active

  }
  tbl_htl_period(where: {sea_id_seq: {_eq: $seaId}}) {
    id_seq
    sea_id_seq
    firm_main_code
    firm_sub_code
    period
    start_date
    end_date
    release
    min_stay
    
  }
  
}
`;

const INSERT_SEA = gql`
  mutation InsertSeason(
    $seaId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
    $seaDesc: String
    $startDate: date
    $endDate: date
    $fmActive: Boolean
   
    
  ) {
    insert_tbl_htl_season(
      objects: {
        firm_main_code: $ownFirmCode,
        firm_sub_code: $ownFirmSubCode,
        id_seq: $seaId,
        desc: $seaDesc,
        start_date: $startDate,
        end_date: $endDate,
        active: $fmActive
        opt_1: "SALDATE"

        
      }
    ) {
      affected_rows
    }
  }
`;

const UPDATE_FIRM = gql`
mutation UpdateFirm(
    $seaId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
    $seaDesc: String
    $startDate: date
    $endDate: date
    $fmActive: Boolean
  ) {
    update_tbl_htl_season(
      where: {
        id_seq: { _eq: $seaId }
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
      }
      _set: {
        desc: $seaDesc
        active: $fmActive
        start_date: $startDate
        end_date: $endDate
      }
    ) {
      affected_rows
    }
  }
`; 

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;


const GET_FILTERED_FIRMS = gql`
  query GetFilteredFirms($ownFirmCode: String, $ownFirmSubCode: String) {
    tbl_htl_room_type(order_by: { r_class_code: asc }, where: { firm_main_code: { _eq: $ownFirmCode }, firm_sub_code: { _eq: $ownFirmSubCode } }) {
      firm_main_code
      firm_sub_code
      r_class_code
      r_type_code
      r_type_name
      total_room
      active
    }
  }
`;

const INSERT_ROOM_TYPE_AVA_STS = gql`
  mutation InsertRoomTypeAvaSts($objects: [tbl_htl_room_type_ava_sts_insert_input!]!) {
    insert_tbl_htl_room_type_ava_sts(objects: $objects) {
      returning {
        firm_main_code
        firm_sub_code
        room_class
        room_type
        date
        capacity
        booking
      }
    }
  }
`;






const HtlHotelSeasons = () => {

   const {varCode, setVarCode} = useContext(ThemeContext);
   const {varCode2, setVarCode2} = useContext(ThemeContext);
  const {userName, setUserName} = useContext(ThemeContext);
  const { users } = useContext(UserContext);

  const ownFirmCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.usertype;
  

  const lang = users.userLang;

  

     
   
  
  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { seaId: varCode, ownFirmCode: ownFirmCode, ownFirmSubCode: ownFirmSubCode  },
  });


  const firmData = data && data.tbl_htl_season ? data.tbl_htl_season[0] : null;
  const firmData2 = data && data.tbl_htl_period ? data.tbl_htl_period[0] : null;
 

  const [updateFirm] = useMutation(UPDATE_FIRM);
  const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2); 
  const [InsertSeason] = useMutation(INSERT_SEA);

  const [displayBasic, setDisplayBasic] = useState(false);

  
  
  
 // const [firmCode, setFirmcode] = useState(firmData ? firmData.firm_main_code_n : "");
 const [firmCode, setFirmCode] = useState('');
 const [firmName, setFirmName] = useState("");
  const [firmType, setFirmType] = useState("AGN");
  const [place, setPlace] = useState("");
  const [fmActive, setFmActive] = useState(firmData ? firmData.active : false); 
  const [seaDesc, setSeaDesc] = useState(firmData ? firmData.firm_sub_code_k : ""); 
  const [seaId, setSeaId] = useState("");
  const [startDate, setStartDate] = useState(firmData ? new Date(firmData.start_date): new Date());
  const [endDate, setEndDate] = useState(firmData ? new Date(firmData.end_date) : new Date());

  const [openModal, setOpenModal] = useState(false);
  const [modalParam, setModalParam] = useState('');
  const [verim, setVerim] = useState('T0002');
  const {theme, setTheme} = useContext(ThemeContext);
  
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
  const new_firm = messages[currentLocale].new_firm;
  const firm_code = messages[currentLocale].firm_code;
  const firm_name = messages[currentLocale].firm_name;
  const firm_type = messages[currentLocale].firm_type;
  const placerec = messages[currentLocale].placerec;
  const int_id = messages[currentLocale].int_id;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const update = messages[currentLocale].update;
  const per_id_title = messages[currentLocale].per_id_title;
  const per_code_title = messages[currentLocale].per_code_title;
  const firm_main_code = messages[currentLocale].firm_main_code;
  const firm_sub_code = messages[currentLocale].firm_sub_code;
  const firm_sub_name = messages[currentLocale].firm_sub_name;
  const typerec = messages[currentLocale].typerec;


  



  const close_form = messages[currentLocale].close_form;
 
  const search_by_name = messages[currentLocale].search_by_name;
  const main_code = messages[currentLocale].main_code;
  const sub_code = messages[currentLocale].sub_code;
  const sea_new_btn = messages[currentLocale].sea_new_btn;
  const sea_Season_title = messages[currentLocale].sea_Season_title;
  
 
  const sea_management_title = messages[currentLocale].sea_management_title;
  const detail = messages[currentLocale].detail;
  
  const sea_id_title = messages[currentLocale].sea_id_title;
  const administrator = messages[currentLocale].administrator;
  const dashboard = messages[currentLocale].dashboard;
  const sea_desc_title = messages[currentLocale].sea_desc_title;
  const start_date_title = messages[currentLocale].start_date_title;
  const end_date_title = messages[currentLocale].end_date_title;
  const sea_new_per_btn = messages[currentLocale].sea_new_per_btn;


  useEffect(() => {
    // newId değeri bağlamdaki yeni değeri yansıtır
    if (seaId !== '') {
      // newId güncellendiğinde setFirmCode işlevini çağırarak firmCode'u güncelliyor
    handleinser();  
    
    }
  }, [seaId, setSeaId]);

  useEffect(() => {
    if (firmData) {
  
        setSeaId(firmData.id_seq);
        setStartDate(new Date(firmData.start_date));
        setEndDate(new Date(firmData.end_date));
        setSeaDesc(firmData.desc);
          
    }
  }, [firmData]);


  const handleUpdate = () => {
   
    
    updateFirm({
      variables: {
        seaId: seaId,
        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,
       
        seaDesc: seaDesc,
        startDate: new Date(startDate).toLocaleDateString(),
        endDate: new Date(endDate).toLocaleDateString(),
        fmActive: fmActive,
        
      },
    })
      .then(() => {
        window.alert("Firm updated successfully!");
        refetch();
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  }; 

  const handleUpdateIdSeq = async () => {
    try {
      const { data } = await updateIdSeq2({
        variables: {
          type: 'MFIRM', 
        },
      });
      const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
      console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
      setSeaId(updatedIdSeq.toString());  
      setVarCode(updatedIdSeq.toString());  
      console.log(seaId);
     
       
      
    } catch (error) {
      console.error('Güncelleme hatası:', error);
    }
  };

  const handleinser = () => {
    InsertSeason({
      variables: {
    seaId: seaId,
    ownFirmCode: ownFirmCode,
    ownFirmSubCode: ownFirmSubCode,
    seaDesc: seaDesc,
    startDate: new Date(startDate).toLocaleDateString(),
    endDate: new Date(endDate).toLocaleDateString(),
    fmActive: fmActive
    
    
           
      },
    })
      .then(() => {
        window.alert("Season insert successfully!");
      })
      .catch((error) => {
        console.error("Error insert Season:", error);
      });
  };


  function getDatesInRange(startDate, endDate) {
    const date = new Date(startDate);
    const dates = [];
  
    while (date <= new Date(endDate)) {
      dates.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
  
    return dates;
  }

  const { loading: loadingFirms, error: errorFirms, data: dataFirms } = useQuery(GET_FILTERED_FIRMS, {
    variables: { ownFirmCode, ownFirmSubCode },
    skip: !ownFirmCode || !ownFirmSubCode
  });

  const [insertRoomTypeAvaSts] = useMutation(INSERT_ROOM_TYPE_AVA_STS);

  const handleInsert = async () => {
    if (!startDate || !endDate || !ownFirmCode || !ownFirmSubCode) {
      alert('Please fill in all fields');
      return;
    }

    if (loadingFirms) {
      alert('Data is loading, please wait');
      return;
    }

    if (errorFirms) {
      console.error('Error fetching data:', errorFirms);
      alert('Error fetching data');
      return;
    }

    if (!dataFirms || !dataFirms.tbl_htl_room_type) {
      console.error('No data found');
      alert('No data found');
      return;
    }

    const dates = getDatesInRange(startDate, endDate);

    const insertObjects = [];

    for (const row of dataFirms.tbl_htl_room_type) {
      for (const date of dates) {
        insertObjects.push({
          firm_main_code: row.firm_main_code,
          firm_sub_code: row.firm_sub_code,
          room_class: row.r_class_code,
          room_type: row.r_type_code,
          date: date.toISOString().split('T')[0], // Tarihi YYYY-MM-DD formatında alır
          capacity: row.total_room,
          booking: 0
        });
      }
    }

    try {
      await insertRoomTypeAvaSts({
        variables: {
          objects: insertObjects
        }
      });

      alert('Data inserted successfully');
    } catch (error) {
      console.error('Error inserting data:', error);
      alert('Error inserting data');
    }
  };


  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

      
  const onClick = () => {
    setDisplayBasic(true);
    
  };

  const onClick2 = () => {
    setVarCode2(0);  
    setDisplayBasic(true);
    
  };
  
  const onHide = () => {
    setDisplayBasic(false);
    refetch();
  };




  return (

    <div className="container p-2 mx-auto sm:p-4 ">
      <div className="card  ">
    
     <div className=" p-2 ">
          <div className="pt-1 -my-14 -ml-14 -mr-14  -mb-5"> 
            <Fieldset>
            <p className="my-0  ">

          <div className="flex gap-4">
          <div className="w-1/5 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{sea_id_title}</label>
    <InputText className="w-full text-base" 
    id="username" value={varCode}
    onChange={(e) => setSeaId(e.target.value)}
    readOnly
    />
  </div>

  <div className="w-4/5 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{sea_Season_title}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={seaDesc} 
    onChange={(e) => setSeaDesc(e.target.value)} autoComplete="off"/>
    
  </div>
 
  </div>

  
  <div className="flex gap-3 my-5">
  
  

  <div className="w-1/3 h-10 gap-3">
        <label                
         htmlFor="firmname"> {start_date_title}</label>
        <Calendar className="w-full h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={startDate} dateFormat="dd/mm/yy"
        onChange={(e) => setStartDate(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>

      <div className="w-1/3 gap-3">
        <label                
         htmlFor="firmname"> {end_date_title}</label>
        <Calendar className="w-1/8 h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={endDate} dateFormat="dd/mm/yy"
        onChange={(e) => setEndDate(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>

  <div className=" flex-col font-medium  flex justify-content-center">
  
  <label htmlFor="firmtype" 
  className=" flex-col  ml-0 mb-5 align-items-center block font-medium text-gray-950">{statusrec} </label><p></p>
  <div className="flex ml-0 flex-wrap gap-6">
  <div className="flex ml-0 align-items-center">
  <RadioButton inputId="ingredient1" name="active" value={true}  onChange={(e) => setFmActive(e.value)} checked={fmActive === true} />
          <label htmlFor="ingredient1" className="ml-2">{activerec}</label>
          
      </div>
      <div className="flex align-items-center">
          <RadioButton inputId="ingredient2" name="inactive" value={false}  onChange={(e) => setFmActive(e.value)} checked={fmActive === false} />
          <label htmlFor="ingredient2" className="ml-2">{inactiverec}</label>
      </div>
      </div>
      </div>  
      </div>
      <div className="flex  gap-4 ">
      <div className="w-2/4">
     
  </div>
  <div className="w-2/4">
    <Button
      label={sea_new_per_btn}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={handleInsert}
    />
  </div>
  <div className="w-2/4">
    <Button
      label={update}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={handleUpdate}
    />
  </div>
  <div className="w-2/4">
    <Button
      label={sea_new_btn}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-500 text-white font-semibold rounded-md"
      onClick={handleUpdateIdSeq}
    />
  </div>
</div>



</p>
    </Fieldset>
        </div>
  
             
        </div>          
       

    
   </div>
  
  
        
     
    </div>

    
    
    
 
 
);
};

export default HtlHotelSeasons;
